"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_input_autosize_1 = __importDefault(require("react-input-autosize"));
const keyDownHandlerProxy_1 = __importDefault(require("../utils/keyDownHandlerProxy"));
const DeleteButton_1 = __importDefault(require("./DeleteButton"));
const constants_1 = require("../constants");
const styles_scss_1 = __importDefault(require("../styles.scss"));
const handleInlineEditClick = (e) => {
    e.stopPropagation();
};
const Token = (props) => {
    const { readOnly, tokenValue, tokenMeta, onGetClassName, onGetDisplayLabel, onRenderDeleteButtonContent, onGetIsEditable, onGetEditableValue, onGetErrorMessage, onBuildTokenValue, onEditStart, onEditEnd, onDelete, } = props;
    const autosizeInputRef = (0, react_1.useRef)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)(constants_1.DEFAULT_INPUT_INIT_VALUE);
    const { activated, error } = tokenMeta;
    const isEditable = (0, react_1.useMemo)(() => {
        return onGetIsEditable(tokenValue, tokenMeta);
    }, [onGetIsEditable, tokenValue, tokenMeta]);
    const handleEditStart = (0, react_1.useCallback)(() => {
        const tokenEditableValue = onGetEditableValue(tokenValue, tokenMeta);
        setInputValue(tokenEditableValue);
        onEditStart();
    }, [setInputValue, tokenValue, tokenMeta, onGetEditableValue, onEditStart]);
    (0, react_1.useEffect)(() => {
        const autosizeInput = autosizeInputRef.current;
        if (activated && autosizeInput) {
            autosizeInput.getInput().focus();
        }
    }, [activated]);
    const handleEditEnd = (0, react_1.useCallback)(({ reset = false } = {}) => {
        const isValueClear = inputValue.length === 0;
        if (reset || isValueClear) {
            onEditEnd();
            return;
        }
        const newTokenValue = onBuildTokenValue(inputValue);
        onEditEnd(newTokenValue);
    }, [inputValue, onBuildTokenValue, onEditEnd]);
    const handleTokenClick = (0, react_1.useCallback)((e) => {
        e.stopPropagation();
        if (readOnly) {
            return;
        }
        const isOnDeleteButton = !!e.target.closest(`.${styles_scss_1.default.token} .${constants_1.JS__TOKEN__DELETE_BUTTON__CLASS_NAME}`);
        if (isOnDeleteButton) {
            onDelete();
            return;
        }
        if (isEditable) {
            handleEditStart();
        }
    }, [readOnly, isEditable, onDelete, handleEditStart]);
    const handleInputValueChange = (0, react_1.useCallback)((e) => {
        const { value } = e.target;
        setInputValue(value);
    }, [setInputValue]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        (0, keyDownHandlerProxy_1.default)(e, {
            onEscape: () => handleEditEnd({ reset: true }),
            onEnter: () => handleEditEnd(),
        });
    }, [handleEditEnd]);
    const handleBlur = (0, react_1.useCallback)(() => {
        handleEditEnd();
    }, [handleEditEnd]);
    const tokenClassName = (0, react_1.useMemo)(() => {
        return (0, classnames_1.default)(onGetClassName === null || onGetClassName === void 0 ? void 0 : onGetClassName(tokenValue, tokenMeta), styles_scss_1.default.token, {
            [styles_scss_1.default['token--read-only']]: readOnly,
            [styles_scss_1.default['token--editable']]: isEditable && !readOnly,
            [styles_scss_1.default['token--active']]: activated,
            [styles_scss_1.default['token--error']]: error && !activated,
        });
    }, [
        onGetClassName,
        readOnly,
        isEditable,
        activated,
        error,
        tokenValue,
        tokenMeta,
    ]);
    const errorMessage = (0, react_1.useMemo)(() => {
        const tokenError = onGetErrorMessage(tokenValue, tokenMeta);
        return typeof tokenError === 'string' ? tokenError : undefined;
    }, [onGetErrorMessage, tokenValue, tokenMeta]);
    if (activated) {
        return (react_1.default.createElement("div", { "data-component-name": "Token", role: "presentation", className: tokenClassName, onClick: handleInlineEditClick },
            react_1.default.createElement("div", { className: styles_scss_1.default['autosized-wrapper'] },
                react_1.default.createElement(react_input_autosize_1.default, { ref: autosizeInputRef, value: inputValue, onChange: handleInputValueChange, onKeyDown: handleKeyDown, onBlur: handleBlur }))));
    }
    return (react_1.default.createElement("div", { "data-component-name": "Token", role: "presentation", className: tokenClassName, onClick: handleTokenClick, title: errorMessage },
        react_1.default.createElement("div", { className: styles_scss_1.default['token__label-wrapper'] }, onGetDisplayLabel(tokenValue, tokenMeta)),
        !readOnly && (react_1.default.createElement(DeleteButton_1.default, { onRenderContent: onRenderDeleteButtonContent }))));
};
exports.default = Token;
